import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { ContractTemplateSelect as LocalContractTemplateSelect } from '../../components/ContractTemplateSelect'

export const ContractTemplateSelect = connect(
  LocalContractTemplateSelect,
  mapReadPretty(LocalContractTemplateSelect, { disabled: true })
)
